<template>
    <div>
        <h1>{{ $t('support.map.contact_info') }}</h1>
        <div>
            <h3 class="my-0">{{ $t('support.map.address') }}:</h3>
            <p class="my-0">{{ address.address }}, {{ address.number }}</p>
            <p class="my-0">{{ address.neighborhood }}, {{ address.zip }}</p>
            <p class="my-0">{{ address.city }} - {{ address.state }}</p>
        </div>
        <div
            v-if="telephones && telephones.length"
            class="telephones mt-3"
        >
            <h3 class="my-0">{{ $t('support.map.telephone') }}:</h3>
            <div v-for="number in telephones" :key="number.id">
                <p class="my-0">{{ number.label }}: {{ number.value }}</p>
            </div>
        </div>
        <div class="my-3 d-flex justify-content-center">
            <div v-for="(social, index) in socials" :key="index">
                <a target="_blank" :href="social.url" class="mx-3 d-flex justify-content-center align-items-center">
                    <i class="socials-icons" :class="social.icon"></i>
                </a>
            </div>
        </div>
    </div>
  
</template>

<script>
export default {
    name: 'ContactInfo',
    props: {
        address: {
            type: Object,
            required: true 
        },
        telephones: {
            type: Array,
            required: true
        },
        socials: {
            type: Array,
            required: true
        }
    }

}
</script>

<style scoped>
.socials-icons {
    font-size: 1.5rem;
    color: #4d4d4d;
}
</style>